import { useTranslation } from 'react-i18next';

import { ConnectionFallback } from '../ConnectionFallback';

interface ConnectToAnyChatProps {
  description?: string;
  to: string;
}

export const ConnectToAnyChat = ({ description, to }: ConnectToAnyChatProps) => {
  const { t } = useTranslation('anychat');

  return (
    <ConnectionFallback
      imgSrc="/assets/anychat/connect-anychat.png"
      imgAlt={t('anychat.shared.connectToAnyChat.alt')}
      title={t('anychat.shared.connectToAnyChat.title')}
      description={description || t('anychat.shared.connectToAnyChat.desc')}
      link={to}
      linkLabel={t('anychat.shared.connectToAnyChat.link')}
    />
  );
};
